var AVAILABLE_READING_DIRECTIONS = ['ltr', 'rtl'];

var trialBook = {
  target: $('#preview-book'),
  nextButton: $('#preview-book-nav-next'),
  prevButton: $('#preview-book-nav-prev'),
  container: $('#preview-book-container'),
  closeButton: $('#preview-book-close'),
  viewButton: $('#preview-book-button'),
  imageTile: $('.preview-book-image'),
  zoomInButton: $('#preview-book-zoom-in'),
  zoomOutButton: $('#preview-book-zoom-out'),

  initTrialBook: function(direction = 'ltr') {
    if (!AVAILABLE_READING_DIRECTIONS.includes(direction)) {
      throw new Error('Invalid reading direction');
    }

    var windowSize = trialBook._windowSize();
    var previewBookOptions = {
      width: windowSize.width > 768 ? '100%' : windowSize.window,
      height: '90vh',
      display: windowSize.width > 768 ? 'double' : 'single',
      duration: 1000,
      elevation: 50,
      when: {
        turned: function (event, page, _view) {
          var pages = trialBook.target.turn('pages');
          if (page === 1) {
            if (direction === 'rtl') {
              trialBook.nextButton.prop('disabled', true);
            } else {
              trialBook.prevButton.prop('disabled', true);
            }
          } else if ((pages % 2 !== 0 && page === (pages - 1)) || page === pages) {
            if (direction === 'rtl') {
              trialBook.prevButton.prop('disabled', true);
            } else {
              trialBook.nextButton.prop('disabled', true);
            }
          }
        },
        turning: function() {
          trialBook.prevButton.prop('disabled', false);
          trialBook.nextButton.prop('disabled', false);
        }
      }
    }

    trialBook.target.attr({ "dir": direction })
    trialBook.target.turn(previewBookOptions);
  },
  updateTrialBook: function() {
    trialBook.target.turn('page', 1);
    trialBook.target.turn('update')
  },
  renderBookImages: function(direction = 'ltr') {
    trialBook.imageTile.each(function() {
      var page = $(this).data('page');
      var position;
      if (page % 2 === 0 && direction === 'rtl' || page % 2 === 1 && direction === 'ltr') {
        position = 'left';
      } else {
        position = 'right';
      }

      var imageUrl = $(this).data('image');
      trialBook._imageContainer(imageUrl, position).appendTo($(this));
    })
  },
  _imageContainer: function(imageUrl, position) {
    return $('<div>', {
      class: 'photo absolute top-0 left-0',
    }).css({
      'background-image': 'url('+ imageUrl +')',
      'background-position-x': position,
      'transition': 'transform .5s ease-out',
      'background-size': 'contain',
      'background-repeat': 'no-repeat',
      'display': 'block',
      'width': '100%',
      'height': '100%',
    })
  },
  handleCloseTrialBook: function() {
    $('body').css({ 'overflow': 'auto' });
    trialBook.container.hide();
  },
  handleNextButtonClick: function(direction = 'ltr') {
    return function() {
      if (direction === 'ltr') {
        trialBook.target.turn('next');
      } else {
        trialBook.target.turn('previous');
      }
    }
  },
  handleZoomInButtonClick: function() {
    trialBook.zoomInButton.hide();
    trialBook.zoomOutButton.show();
    trialBook.imageTile
      .on('mouseover', function(){
        var scale = $(this).data('scale');
        $(this).children('.photo').css({'transform': 'scale('+ scale +')'});
      })
      .on('mouseout', function(){
        $(this).children('.photo').css({'transform': 'scale(1)'});
      })
      .on('mousemove', function(e){
        var xOffset = ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '%';
        var yOffset = ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + '%';
        var offset = [xOffset, yOffset].join(' ');

        $(this).children('.photo').css({'transform-origin': offset});
      })
      .css({ 'cursor': 'zoom-in' })
  },
  handleZoomOutButtonClick: function() {
    trialBook.zoomInButton.show();
    trialBook.zoomOutButton.hide();
    trialBook.imageTile
      .off('mouseover')
      .off('mouseout')
      .off('mousemove')
      .css({ 'cursor': 'default' })
  },
  handlePrevButtonClick: function(direction = 'ltr') {
    return function() {
      if (direction === 'ltr') {
        trialBook.target.turn('previous');
      } else {
        trialBook.target.turn('next');
      }
    }
  },
  _windowSize: function() {
    return {
      width: $(window).width(),
      height: $(window).height()
    }
  },
}
